import { render, staticRenderFns } from "./DashboardAnalysisTable.vue?vue&type=template&id=630b2cf4&scoped=true&"
import script from "./DashboardAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./DashboardAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAnalysisTable.vue?vue&type=style&index=0&id=630b2cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630b2cf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VIcon,VTooltip})
